<template>
  <patientDetailComponent :isMy="true"></patientDetailComponent>
</template>
<script>

const files = require.context('/', false, /\.vue$/);
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2);
import patientDetailComponent from '@/components/patient/patientDetail.vue'
export default {
  name: `patientmymyDetail`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
    console.log(suffixList)
  },
  components: {
    patientDetailComponent
  }
}
</script>